import React from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from 'framer-motion';

import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import NotFound from './pages/NotFound';

import ArtHome from './pages/art/ArtHome';
import Gallery from './pages/art/Gallery';
import Projects from './pages/art/Projects';
import ProjectDetail from './pages/art/ProjectDetail';
import Commissions from './pages/art/Commissions';

import StreamHome from './pages/stream/StreamHome';

function App() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />

          {/* Legal Pages */}
          <Route path="legal" element={<Legal />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="cookies" element={<Cookies />} />
          
          {/* Art Ecosystem */}
          <Route path="art">
            <Route index element={<ArtHome />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            <Route path="commissions" element={<Commissions />} />
          </Route>

          {/* Stream Ecosystem */}
          <Route path="stream">
            <Route index element={<StreamHome />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

export default App;
